export default __webpack_public_path__ + "static/media/new_avatar.3bbfa889.png";